LIMIT_REPLACE_NODE